import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import './style.scss';

const CPPListDocuments = (props) => {
  function setTab() {
    props.setActiveCPPTab('documents');
  }

  return (
    <div className="cpp-small-box list-documents">
      <div className="top-info row clickable" onClick={setTab}>
        <Icon src={props.icon} width="20px" height="20px" />
        <span className="small-title uppercase">{props.title}</span>
      </div>
    </div>
  );
};

CPPListDocuments.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  bubble: PropTypes.object,
  patient: PropTypes.object,
  setActiveCPPTab: PropTypes.func,
};

export default CPPListDocuments;
